define('models/validator/length',["backbone",
        "models/validator/_base/basevalidator"
], function (Backbone, BaseValidator) {
    "use strict";

    return BaseValidator.extend({

        defaults: {
            validationType: enums.validationType.length,
        },

        validate: function(val, min, max) {
            this.set('value', val);
            var code = this.validateHasValue(val);
            if ( this.isValid(code) ) {
                code = this.validateLength(val, min, max);
            }

            this.set('validationCode', code);
            return code;
        },

        validateLength: function(val, min, max) {
            var length = val.length,
                code;
            if (length < min) {
                code = enums.validationCode.tooShort;
            } else if (length > max) {
                code = enums.validationCode.tooLong;
            } else {
                code = enums.validationCode.ok;
            }
            return code;
        }
    });
});
